import { render, staticRenderFns } from "./VuesticKycSelect.vue?vue&type=template&id=2a50fa9e"
import script from "./VuesticKycSelect.vue?vue&type=script&lang=js"
export * from "./VuesticKycSelect.vue?vue&type=script&lang=js"
import style0 from "./VuesticKycSelect.vue?vue&type=style&index=0&id=2a50fa9e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a50fa9e')) {
      api.createRecord('2a50fa9e', component.options)
    } else {
      api.reload('2a50fa9e', component.options)
    }
    module.hot.accept("./VuesticKycSelect.vue?vue&type=template&id=2a50fa9e", function () {
      api.rerender('2a50fa9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/waybill-simple-select/VuesticKycSelect.vue"
export default component.exports